/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/display-name */

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { View } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
// import Toast from 'react-native-toast-message';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@components/global/Alert';
import BarcodeScanner from '@components/global/BarcodeScanner';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';
import { logEvent } from '@global/analytics';

import {
  limit,
  searchLimit,
  createEmptyVisibilityBrowseState,
  mergeProductsByCombination,
  convertProductResult,
  ensureNormalized,
  buildVisibilityPayloadProducts,
  getVisibilityProductIdentity,
  getVisibilityCombinationIdentifier,
  getVisibilityProductIdentifier,
  getVisibilityProductReference,
  dedupeVisibilityProducts,
  flattenVisibilitySearchResponse,
  normalizeVisibilityApiProducts,
  normalizeVisibilityBrandList,
  applyExactEanMatch,
  sanitizeVisibilityProductsByBrand,
  sanitizeVisibilityBrowseSkip,
  sanitizeVisibilityBrowseEmpty,
  applyExpandedVisibilityBrands,
  buildVisibilityBrowseSnapshot,
  filterVisibilityProductsByKeyword,
  formatVisibilityProductsForList,
  extractVisibilitySelectedProducts,
  buildVisibilityProductBuckets,
} from './TodoVisibilityUpdate.utils';
import VisibilityValidationModal from './VisibilityValidationModal';
import VisibilityProductNotFoundModal from './VisibilityProductNotFoundModal';
import VisibilityBrowseSection from './VisibilityBrowseSection';
import VisibilitySelectedSection from './VisibilitySelectedSection';

const LIMIT_AMOUNT = 2000;
const REQUEST_TIMEOUT_MS = 15000;
const VISIBILITY_CACHE_PREFIX = 'B2B-VISIBILITY-CACHE';

const isBrandProductsChanged = (prevProducts = [], nextProducts = []) => {
  if ((prevProducts?.length || 0) !== (nextProducts?.length || 0)) {
    return true;
  }
  for (let i = 0; i < (nextProducts?.length || 0); i++) {
    if (
      getVisibilityProductIdentity(prevProducts[i]) !==
      getVisibilityProductIdentity(nextProducts[i])
    ) {
      return true;
    }
  }
  return false;
};

const TodoVisibilityUpdate = ({
  containerHeight = 0,
  detailData = {},
  detailTodo = {},
  detailCustomer = {},
  onSubmit = () => {},
  resetTab = () => {},
  customerAddress = {},
  navigation = {},
  localPayload = null,
  onSaveDraft = () => {},
}) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  // B2B-5929: online platforms only share value sell out, so promotor online
  // activities input value sell out only
  const isValueSellOutOnly =
    (userData?.role?.code || userData?.role || '') === 'promotor' &&
    detailData?.category_activity === 'ONLINE';
  const isLoadingGlobal = useSelector((state) => state.modal.isLoading);
  const [showProduct, setShowProduct] = useState(false);
  const [loading, setLoading] = useState({
    search: false,
  });
  const [isSearch, setIsSearch] = useState(false);
  const [skip, setSkip] = useState({
    result: 0,
  });
  const [empty, setEmpty] = useState({});
  const [loadingMore, setLoadingMore] = useState({});
  const [lastPayload, setLastPayload] = useState([]);
  const [lastPayloadOther, setLastPayloadOther] = useState([]);
  const [listProduct, setListProduct] = useState({});
  const [listProductSearch, setListProductSearch] = useState([]);
  const [listBrand, setListBrand] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [modalValidation, setModalValidation] = useState(false);
  const [missingFieldData, setMissingFieldData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const [activeTab, setActiveTab] = useState('default');
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [showScanner, setShowScanner] = useState(false);
  const [scannedEAN, setScannedEAN] = useState('');
  const [showProductNotFoundModal, setShowProductNotFoundModal] =
    useState(false);
  const [isBarcodeScanning, setIsBarcodeScanning] = useState(false);
  const lastPayloadRef = React.useRef([]);
  const lastPayloadOtherRef = React.useRef([]);
  const listProductSearchRef = React.useRef([]);
  const activeSearchKeywordRef = React.useRef('');
  const brandListsRef = React.useRef([]);
  const selectedBrandRef = React.useRef([]);
  const loadingRef = React.useRef({ search: false });
  const browseSnapshotRef = React.useRef(createEmptyVisibilityBrowseState());
  const visibilityCacheRef = React.useRef(null);
  const listProductRef = React.useRef({});
  const listBrandRef = React.useRef([]);
  const skipRef = React.useRef({ result: 0 });
  const emptyRef = React.useRef({});
  const visibilityCacheKey = useMemo(() => {
    const activityId = detailData?._id ?? '';
    if (!activityId) {
      return '';
    }
    return `${VISIBILITY_CACHE_PREFIX}-${activityId}`;
  }, [detailData?._id]);

  const persistBrowseSnapshot = async ({
    brands = null,
    productsByBrand = null,
    skipValue = null,
    emptyValue = null,
    selectedBrands = null,
  } = {}) => {
    const nextBrands = normalizeVisibilityBrandList(
      brands ??
        browseSnapshotRef.current?.brands ??
        brandListsRef.current ??
        listBrandRef.current,
    );
    const nextProductsByBrand = sanitizeVisibilityProductsByBrand(
      productsByBrand ??
        browseSnapshotRef.current?.productsByBrand ??
        listProductRef.current,
    );
    const nextSkip = sanitizeVisibilityBrowseSkip(
      skipValue ?? browseSnapshotRef.current?.skip ?? skipRef.current,
    );
    const nextEmpty = sanitizeVisibilityBrowseEmpty(
      emptyValue ?? browseSnapshotRef.current?.empty ?? emptyRef.current,
    );
    const nextSelectedBrand = Array.isArray(selectedBrands)
      ? selectedBrands
      : browseSnapshotRef.current?.selectedBrand ?? [];
    const nextSnapshot = buildVisibilityBrowseSnapshot({
      brands: nextBrands,
      productsByBrand: nextProductsByBrand,
      skip: nextSkip,
      empty: nextEmpty,
      selectedBrand: nextSelectedBrand,
    });

    browseSnapshotRef.current = nextSnapshot;
    visibilityCacheRef.current = {
      ...(visibilityCacheRef.current ?? {}),
      ...nextSnapshot,
    };

    await writeVisibilityCache(nextSnapshot);
  };

  const restoreBrowseState = async () => {
    const currentSnapshot =
      browseSnapshotRef.current ?? createEmptyVisibilityBrowseState();
    const hasSnapshot =
      (currentSnapshot?.brands?.length ?? 0) > 0 ||
      Object.keys(currentSnapshot?.productsByBrand ?? {}).length > 0;

    const cachedBrowse = hasSnapshot
      ? currentSnapshot
      : visibilityCacheRef.current ?? (await readVisibilityCache());

    const restoredBrands = normalizeVisibilityBrandList(
      cachedBrowse?.brands?.length
        ? cachedBrowse.brands
        : brandListsRef.current,
    );
    const restoredProductsByBrand = sanitizeVisibilityProductsByBrand(
      cachedBrowse?.productsByBrand,
    );
    const restoredSkip = sanitizeVisibilityBrowseSkip(cachedBrowse?.skip);
    const restoredEmpty = sanitizeVisibilityBrowseEmpty(cachedBrowse?.empty);
    const restoredSelectedBrand = (cachedBrowse?.selectedBrand ?? []).filter(
      (brandId) => restoredBrands.some((brand) => brand._id === brandId),
    );

    if (restoredBrands.length) {
      brandListsRef.current = restoredBrands;
    }

    browseSnapshotRef.current = buildVisibilityBrowseSnapshot({
      brands: restoredBrands,
      productsByBrand: restoredProductsByBrand,
      skip: restoredSkip,
      empty: restoredEmpty,
      selectedBrand: restoredSelectedBrand,
    });

    setListBrand(
      applyExpandedVisibilityBrands(restoredBrands, restoredSelectedBrand),
    );
    setListProduct(restoredProductsByBrand);
    setSelectedBrand(restoredSelectedBrand);
    setSkip(restoredSkip);
    setEmpty(restoredEmpty);
    setListProductSearch([]);
    setLoading({ search: false });
    setLoadingMore({});
    setIsSearch(false);
  };

  const readVisibilityCache = useCallback(async () => {
    if (!visibilityCacheKey) {
      return null;
    }
    try {
      const raw = await AsyncStorage.getItem(visibilityCacheKey);
      if (raw) {
        return JSON.parse(raw);
      }
      const legacyPrefix = `${VISIBILITY_CACHE_PREFIX}-${
        detailData?._id ?? ''
      }-`;
      const allKeys = await AsyncStorage.getAllKeys();
      const legacyKeys = allKeys.filter((key) => key.startsWith(legacyPrefix));
      if (!legacyKeys.length) {
        return null;
      }
      const entries = await AsyncStorage.multiGet(legacyKeys);
      const parsedEntries = entries
        .map((entry) => {
          const [, value] = entry;
          try {
            return value ? JSON.parse(value) : null;
          } catch (error) {
            return null;
          }
        })
        .filter(Boolean)
        .sort((a, b) => {
          const aTime = new Date(a?.updatedAt || 0).getTime();
          const bTime = new Date(b?.updatedAt || 0).getTime();
          return bTime - aTime;
        });
      return parsedEntries[0] ?? null;
    } catch (error) {
      return null;
    }
  }, [visibilityCacheKey, detailData?._id]);

  const writeVisibilityCache = useCallback(
    async (payload = {}) => {
      if (!visibilityCacheKey) {
        return;
      }
      try {
        await AsyncStorage.setItem(
          visibilityCacheKey,
          JSON.stringify({
            ...(payload ?? {}),
            updatedAt: new Date().toISOString(),
          }),
        );
      } catch (error) {}
    },
    [visibilityCacheKey],
  );

  useEffect(() => {
    let mounted = true;
    const warmupCache = async () => {
      const cache = await readVisibilityCache();
      if (!mounted) {
        return;
      }
      visibilityCacheRef.current = cache;
    };
    warmupCache();
    return () => {
      mounted = false;
    };
  }, [readVisibilityCache]);

  const storeDeleteId = async (visibilityId) => {
    try {
      const storageKey = `TODO_VISIBILITY_DELETE_IDS_${detailData._id}_${detailTodo._id}`;
      const res = await AsyncStorage.getItem(storageKey);
      const ids = res ? JSON.parse(res) : [];

      if (!ids.includes(visibilityId)) {
        ids.push(visibilityId);
        await AsyncStorage.setItem(storageKey, JSON.stringify(ids));
      }
    } catch (error) {}
  };

  const handleProductUpdate = useCallback(
    (updatedItem, isOther = false) => {
      const setter = isOther ? setLastPayloadOther : setLastPayload;

      setter((prevList) => {
        const list = Array.isArray(prevList) ? [...prevList] : [];

        if (!updatedItem) {
          return list;
        }

        const items = Array.isArray(updatedItem)
          ? updatedItem.map((u) => ensureNormalized(u, true, false))
          : [ensureNormalized(updatedItem, true, false)];

        items.forEach((item) => {
          const index = list.findIndex(
            (pr) =>
              getVisibilityProductIdentifier(pr)?.toString() ===
                getVisibilityProductIdentifier(item)?.toString() &&
              getVisibilityCombinationIdentifier(pr)?.toString() ===
                getVisibilityCombinationIdentifier(item)?.toString(),
          );

          const shouldDelete = item._isDeleted || item.is_selected === false;

          if (shouldDelete) {
            if (index > -1) {
              const visibilityId = item._id;
              if (shouldDelete && visibilityId) {
                storeDeleteId(visibilityId);
              }
              list.splice(index, 1);
            }
          } else {
            if (index > -1) {
              list[index] = { ...list[index], ...item };
            } else {
              list.push(item);
            }
          }
        });

        return list;
      });
    },
    [detailData._id, detailTodo._id],
  );

  useEffect(() => {
    listProductRef.current = listProduct;
  }, [listProduct]);

  useEffect(() => {
    lastPayloadRef.current = lastPayload;
  }, [lastPayload]);

  useEffect(() => {
    lastPayloadOtherRef.current = lastPayloadOther;
  }, [lastPayloadOther]);

  useEffect(() => {
    listProductSearchRef.current = listProductSearch;
  }, [listProductSearch]);

  useEffect(() => {
    selectedBrandRef.current = selectedBrand;
  }, [selectedBrand]);

  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);

  useEffect(() => {
    listBrandRef.current = listBrand;
  }, [listBrand]);

  useEffect(() => {
    skipRef.current = skip;
  }, [skip]);

  useEffect(() => {
    emptyRef.current = empty;
  }, [empty]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 800);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    if (
      isBarcodeScanning &&
      !loading.search &&
      !(getProductSearch && getProductSearch.loading) &&
      scannedEAN
    ) {
      const checkTimeout = setTimeout(() => {
        if (
          listProductSearch.length === 0 &&
          empty.search === true &&
          scannedEAN
        ) {
          setShowProductNotFoundModal(true);
          setScannedEAN('');
          setSearchQuery('');
          setDebouncedQuery('');
          setIsBarcodeScanning(false);
        } else if (listProductSearch.length > 0) {
          setIsBarcodeScanning(false);
        }
      }, 500);

      return () => {
        clearTimeout(checkTimeout);
      };
    }
  }, [
    isBarcodeScanning,
    loading.search,
    listProductSearch,
    empty.search,
    scannedEAN,
  ]);

  const filterProducts = (products) => {
    return filterVisibilityProductsByKeyword(products, debouncedQuery);
  };

  const isHasSearchLoadMore =
    listProductSearch?.length > 0 && isSearch && !empty.search;

  const getBrands = useApi(MsB2b.getBrands);
  const getProducts = useApi(MsB2b.getProducts);
  const getProductSearch = useApi(MsB2b.getProductSearch);
  // const getOtherProducts = useApi(MsB2b.getOtherProducts);

  useEffect(() => {
    let mounted = true;
    const init = async () => {
      if (!mounted || !showProduct) {
        return;
      }
      onReset();
      const cache = visibilityCacheRef.current ?? (await readVisibilityCache());
      visibilityCacheRef.current = cache;
      const cachedSelectedBrand = Array.isArray(cache?.selectedBrand)
        ? cache.selectedBrand
        : [];
      if (cache?.brands?.length) {
        const cachedBrands = applyExpandedVisibilityBrands(
          cache.brands,
          cachedSelectedBrand,
        );
        brandListsRef.current = normalizeVisibilityBrandList(cache.brands);
        setListBrand(cachedBrands);
      }
      if (cache?.productsByBrand && typeof cache.productsByBrand === 'object') {
        setListProduct(
          sanitizeVisibilityProductsByBrand(cache.productsByBrand),
        );
      }
      if (cache?.skip && typeof cache.skip === 'object') {
        setSkip((prev) => ({
          ...prev,
          ...sanitizeVisibilityBrowseSkip(cache.skip),
        }));
      }
      if (cache?.empty && typeof cache.empty === 'object') {
        setEmpty((prev) => ({
          ...prev,
          ...sanitizeVisibilityBrowseEmpty(cache.empty),
        }));
      }
      setSelectedBrand(cachedSelectedBrand);
      browseSnapshotRef.current = buildVisibilityBrowseSnapshot({
        brands: cache?.brands,
        productsByBrand: cache?.productsByBrand,
        skip: cache?.skip,
        empty: cache?.empty,
        selectedBrand: cachedSelectedBrand,
      });
      onSearchBrands();
    };
    init();
    return () => {
      mounted = false;
    };
  }, [showProduct, readVisibilityCache]);

  useEffect(() => {
    if (isInitialLoad) {
      if (!localPayload) {
        return;
      }

      const localProducts =
        localPayload?.products_raw ?? localPayload?.products ?? [];

      const localDefault = localProducts.filter((p) => !p?.is_other);
      const localOther = localProducts.filter((p) => p?.is_other);

      setLastPayload(localDefault);
      setLastPayloadOther(localOther);
    }
    return () => {
      setIsInitialLoad(false);
    };
  }, []);

  const onReset = () => {
    setSearchQuery('');
    setDebouncedQuery('');
    activeSearchKeywordRef.current = '';
    setIsSearch(false);
    setLoading({ search: false });
    setLoadingMore({});
    setListProductSearch([]);
    setListProduct({});
    setSkip({ result: 0 });
    setEmpty({});
    setSelectedBrand([]);
    brandListsRef.current = [];
    browseSnapshotRef.current = createEmptyVisibilityBrowseState();
  };

  const onExpand = (brand_id) => {
    if (!isSearch) {
      const currentSelected = selectedBrandRef.current || [];
      const isSelected = currentSelected.indexOf(brand_id) > -1;
      const selected = isSelected
        ? currentSelected.filter((id) => id !== brand_id)
        : currentSelected.concat(brand_id);

      selectedBrandRef.current = selected;
      setSelectedBrand(selected);
      setListBrand((prev) =>
        prev.map((item) => ({
          ...item,
          _expanded: selected.indexOf(item._id) > -1,
        })),
      );

      if (isSelected) {
        persistBrowseSnapshot({
          brands: brandListsRef.current,
          productsByBrand: listProductRef.current,
          skipValue: skipRef.current,
          emptyValue: emptyRef.current,
          selectedBrands: selected,
        });
      } else {
        const cachedProductsByBrand = sanitizeVisibilityProductsByBrand(
          visibilityCacheRef.current?.productsByBrand,
        );
        const cachedBrandProducts = cachedProductsByBrand?.[brand_id];
        const hasStateProducts = Array.isArray(
          listProductRef.current?.[brand_id],
        );
        const hasCachedProducts = Array.isArray(cachedBrandProducts);
        const hasKnownEmpty =
          emptyRef.current?.[brand_id] === true ||
          visibilityCacheRef.current?.empty?.[brand_id] === true;

        if (!hasStateProducts && hasCachedProducts) {
          setListProduct((prev) => ({
            ...sanitizeVisibilityProductsByBrand(prev),
            [brand_id]: cachedBrandProducts,
          }));
        }

        if (!hasStateProducts && hasKnownEmpty) {
          setListProduct((prev) => ({
            ...sanitizeVisibilityProductsByBrand(prev),
            [brand_id]: [],
          }));
          setEmpty((prev) => ({ ...prev, [brand_id]: true }));
        }

        persistBrowseSnapshot({
          brands: brandListsRef.current,
          productsByBrand: hasStateProducts
            ? listProductRef.current
            : {
                ...cachedProductsByBrand,
                ...(hasKnownEmpty ? { [brand_id]: [] } : {}),
                ...(hasCachedProducts
                  ? { [brand_id]: cachedBrandProducts }
                  : {}),
              },
          skipValue: skipRef.current,
          emptyValue: {
            ...emptyRef.current,
            ...(hasKnownEmpty ? { [brand_id]: true } : {}),
          },
          selectedBrands: selected,
        });

        if (!loadingRef.current?.[brand_id]) {
          if (!hasStateProducts && !hasCachedProducts && !hasKnownEmpty) {
            setLoadingProduct(brand_id, true);
            onSearchProducts({
              keyword: '',
              brand_id: brand_id,
              silentRefresh: false,
            });
          }
        }
      }
    }
  };

  const checkMandatoryFields = (products, payload_products) => {
    const isPromotor =
      (userData?.role?.code || userData?.role || '') === 'promotor';

    // B2B-5929: only value sell out is shown for online, stock fields are not filled
    if (isValueSellOutOnly) {
      return [];
    }

    return products
      .filter((p) => !p.is_beginning)
      .map((product) => {
        const {
          sell_in,
          sell_out,
          return: ret,
          result_quantity,
          is_beginning,
          product_id,
          combination_id,
          product_name,
        } = product;

        const missingFields = [];
        const maxFields = [];

        const isMissing = (val) =>
          val === undefined || val === '' || val === null;
        const numeric = (val) => Number(val) || 0;

        if (isMissing(sell_in)) {
          missingFields.push('sell_in');
        }
        if (isMissing(sell_out)) {
          missingFields.push('sell_out');
        }
        if (!isPromotor && (isMissing(ret) || sell_out === null)) {
          missingFields.push('return');
        }
        if (
          is_beginning === false &&
          (isMissing(result_quantity) || isNaN(result_quantity))
        ) {
          missingFields.push('result_quantity');
        }

        if (
          !missingFields.includes('sell_in') &&
          numeric(sell_in) > LIMIT_AMOUNT
        ) {
          maxFields.push('sell_in');
        }
        if (
          !missingFields.includes('sell_out') &&
          numeric(sell_out) > LIMIT_AMOUNT
        ) {
          maxFields.push('sell_out');
        }
        if (
          !isPromotor &&
          !missingFields.includes('return') &&
          numeric(ret) > LIMIT_AMOUNT
        ) {
          maxFields.push('return');
        }

        const matched = payload_products.find(
          (p2) =>
            getVisibilityProductIdentifier(p2) === product_id &&
            getVisibilityCombinationIdentifier(p2)?.toString() ===
              (combination_id || '').toString(),
        );

        if (missingFields.length === 0) {
          return null;
        }

        return {
          product_id,
          combination_id,
          product_name,
          missing_fields: missingFields,
          max_fields: maxFields,
          reference: matched?.combination?.reference ?? '',
          image: matched?.image ?? '',
          current_values: {
            sell_in,
            sell_out,
            return: ret,
            result_quantity,
            quantity: product?.quantity,
          },
        };
      })
      .filter(Boolean);
  };

  const recomputeMissingFieldData = useCallback(
    (defaultProducts = [], otherProducts = []) => {
      const { products, payloadProducts } = buildVisibilityPayloadProducts({
        defaultProducts,
        otherProducts,
        isValueSellOutOnly,
      });
      const nextMissing = checkMandatoryFields(products, payloadProducts);
      setMissingFieldData(nextMissing);
      return nextMissing;
    },
    [checkMandatoryFields, isValueSellOutOnly],
  );

  const onUpdateValidationField = useCallback(
    ({ productId = '', combinationId = '', reference = '', field, value }) => {
      if (!field || !productId) {
        return;
      }

      const normalizeValue = () => {
        if (value === '' || value === null || value === undefined) {
          return '';
        }
        const num = Number(value);
        return isNaN(num) ? '' : num;
      };

      const nextValue = normalizeValue();
      const updateList = (list = []) =>
        (list || []).map((item) => {
          const itemProductId =
            getVisibilityProductIdentifier(item)?.toString();
          const itemCombinationId =
            getVisibilityCombinationIdentifier(item)?.toString();
          const itemReference = getVisibilityProductReference(item);

          const isMatch =
            itemProductId === productId.toString() &&
            ((combinationId &&
              itemCombinationId === combinationId.toString()) ||
              (!combinationId && reference && itemReference === reference) ||
              (!combinationId && !reference));

          if (!isMatch) {
            return item;
          }

          const updated = {
            ...item,
            is_selected: true,
          };

          if (field === 'return') {
            updated.return = nextValue;
          } else if (field === 'result_quantity') {
            updated.result_quantity = nextValue;
            updated.endingStock = nextValue;
          } else if (field === 'quantity') {
            updated.quantity = nextValue;
            if (item?.is_beginning) {
              updated.stock = nextValue;
            }
          } else {
            updated[field] = nextValue;
          }

          return updated;
        });

      const nextDefault = updateList(lastPayloadRef.current);
      const nextOther = updateList(lastPayloadOtherRef.current);

      setLastPayload(nextDefault);
      setLastPayloadOther(nextOther);
      recomputeMissingFieldData(nextDefault, nextOther);
    },
    [recomputeMissingFieldData],
  );

  const saveDraftRef = React.useRef(onSaveDraft);

  useEffect(() => {
    saveDraftRef.current = onSaveDraft;
  }, [onSaveDraft]);

  useEffect(() => {
    const save = async () => {
      if (!saveDraftRef.current) {
        return;
      }
      const { products, products_raw } = buildVisibilityPayloadProducts({
        defaultProducts: lastPayload,
        otherProducts: lastPayloadOther,
        isValueSellOutOnly,
      });
      const payload = {
        products,
        products_raw,
      };

      saveDraftRef.current({
        targetType: 'visibility_update',
        taskId: detailTodo?._id,
        payload,
      });
    };

    save();
  }, [lastPayload, lastPayloadOther, detailTodo?._id, isValueSellOutOnly]);

  const onSubmitProduct = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const { products, products_raw, payloadProducts } =
        buildVisibilityPayloadProducts({
          defaultProducts: lastPayload,
          otherProducts: lastPayloadOther,
          isValueSellOutOnly,
        });
      const payload = {
        products,
        products_raw,
      };

      const missingValueValidation = checkMandatoryFields(
        payload.products,
        payloadProducts,
      );

      const roleCode = userData?.role?.code || userData?.role || '';
      if (roleCode === 'merchandiser') {
        const promoIncomplete = payload.products.filter(
          (p) =>
            p.promo_status === 'implemented' &&
            (!p.promo_list || p.promo_list.length === 0),
        );
        if (promoIncomplete.length > 0) {
          const names = promoIncomplete
            .map((p) => p.product_name || 'Product')
            .join(', ');
          dispatch(showPopup({ name: 'isLoading', value: false }));
          dispatch(
            showAlert({
              show: true,
              isModal: true,
              title: 'Incomplete Promotion',
              description: `Please select at least one promotion for: ${names}`,
              isConfirm: false,
            }),
          );
          return;
        }
      }

      if (
        missingValueValidation.length > 0 &&
        !['salesman', 'merchandiser'].includes(roleCode)
      ) {
        setMissingFieldData(missingValueValidation);
        dispatch(showPopup({ name: 'isLoading', value: false }));
        setModalValidation(true);
      } else {
        logEvent({
          eventName: 'submit_activity',
          data: {
            activity_id: detailData?._id,
            task_id: detailTodo?._id,
            type: 'visibility_update',
            payload: JSON.stringify(payload),
          },
          dataKey: 'detail',
        });
        await onSubmit({
          targetType: 'visibility_update',
          taskId: detailTodo?._id,
          payload,
        });
        dispatch(showPopup({ name: 'isLoading', value: false }));
        resetTab();
      }
    } catch (error) {
      onSubmitError(error);
    }
  };

  const onSubmitError = (error) => {
    dispatch(showPopup({ name: 'isLoading', value: false }));
    let error_message = 'A system error occurred';
    if (error?.response?.data?.message) {
      error_message = error.response.data.message;
    }
    if (!detailTodo?._id) {
      error_message = 'This activity have no todo list activity.';
    }
    dispatch(
      showAlert({
        show: true,
        isModal: true,
        title: 'Error',
        description: error_message,
        isConfirm: false,
        testID: 'todo-visibility-update-error',
      }),
    );
  };

  const setLoadingProduct = (type = 'search', value = true, more = false) => {
    if (more) {
      setLoadingMore((prev) => ({ ...prev, [type]: value }));
    } else {
      setLoading((prev) => ({ ...prev, [type]: value }));
    }
  };

  const requestWithTimeout = useCallback(
    async (requestPromise, timeoutMs = REQUEST_TIMEOUT_MS) => {
      let timeoutId = null;
      const safeRequest = requestPromise
        .then((response) => response)
        .catch(() => ({ success: false, data: null }));
      const timeoutPromise = new Promise((resolve) => {
        timeoutId = setTimeout(
          () => resolve({ success: false, data: null, __timeout: true }),
          timeoutMs,
        );
      });
      const result = await Promise.race([safeRequest, timeoutPromise]);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      return result;
    },
    [],
  );

  const onSearchProducts = async ({
    keyword = '',
    brand_id = '',
    product_skip = 0,
    silentRefresh = false,
  }) => {
    try {
      const effectiveKeyword =
        !brand_id && product_skip > 0 && !keyword
          ? activeSearchKeywordRef.current
          : keyword;

      if (!brand_id) {
        activeSearchKeywordRef.current = effectiveKeyword;
      }

      const filter = {};
      if (!brand_id && !effectiveKeyword && product_skip <= 0) {
        await restoreBrowseState();
        if (!brandListsRef.current.length) {
          onSearchBrands();
        }
        return;
      }
      if (brand_id) {
        if (product_skip <= 0) {
          setEmpty((prev) => ({ ...prev, [brand_id]: false }));
        }
        setSkip((prev) => ({
          ...prev,
          [brand_id]: product_skip,
        }));
        if (!silentRefresh || product_skip > 0) {
          setLoadingProduct(brand_id, true, product_skip > 0);
        }
        filter['brand.id'] = brand_id;
      } else {
        setSkip((prev) => ({
          ...prev,
          search: product_skip,
        }));
        setLoadingProduct('search', true, product_skip > 0);
      }

      if (effectiveKeyword) {
        setIsSearch(true);
        filter['keyword'] = effectiveKeyword;
      } else {
        if (!brand_id) {
          setIsSearch(true);
          filter['keyword'] = effectiveKeyword;
        } else {
          if (product_skip <= 0) {
            setIsSearch(false);
          }
        }
      }

      let res_products = [];
      let res_new_products = [];
      const market_type = detailCustomer?.market_type;
      const market_type_code = market_type?.code.toLowerCase();
      const account_id =
        detailCustomer?.market_type?.business_type?.account?.id;
      const isNonGT =
        account_id && account_id.length && market_type_code != 'gt';
      const addressIsPremium = customerAddress?.address?.is_premium;
      if (detailTodo?._id) {
        filter['task_id'] = detailTodo._id;
        if (isNonGT) {
          filter['account_id'] = account_id;
        }
        if (addressIsPremium !== undefined && addressIsPremium !== null) {
          filter['is_premium'] = addressIsPremium;
        }
      }

      if (brand_id) {
        if (product_skip > 0) {
          res_products = JSON.parse(
            JSON.stringify(listProductRef.current?.[brand_id] || []),
          );
        }

        const response = await requestWithTimeout(
          getProducts.request(
            market_type?.id,
            isNonGT
              ? market_type?.business_type?.account?.id
              : market_type?.business_type?.id,
            {
              params: {
                filter: filter,
                skip: product_skip,
                limit: limit,
                sort: 'product.name',
              },
            },
          ),
        );
        const brandResponseData = Array.isArray(response?.data?.data)
          ? response.data.data
          : null;

        if (brandResponseData?.length) {
          setEmpty((prev) => ({
            ...prev,
            [brand_id]: brandResponseData.length < limit,
          }));
          const result = applyExactEanMatch(
            normalizeVisibilityApiProducts(brandResponseData, {
              markFromDB: true,
            }),
            effectiveKeyword,
          );

          res_new_products = result;
          res_products = res_products.concat(result);
        } else if (brandResponseData) {
          setEmpty((prev) => ({ ...prev, [brand_id]: true }));
        }
      } else {
        if (product_skip > 0) {
          res_products = JSON.parse(
            JSON.stringify(listProductSearchRef.current || []),
          );
        }

        const baseFilter = {
          ...filter,
          market_type_id: market_type?.id,
          business_type_id: market_type?.business_type?.id,
        };

        if (account_id && account_id.length && market_type_code != 'gt') {
          baseFilter.account_id = account_id;
          if (addressIsPremium !== undefined && addressIsPremium !== null) {
            baseFilter.is_premium = addressIsPremium;
          }
        }

        const availableBrands =
          (Array.isArray(brandListsRef.current) && brandListsRef.current.length
            ? brandListsRef.current
            : listBrand) || [];

        const matchedBrandIds =
          effectiveKeyword && effectiveKeyword.trim().length
            ? availableBrands
                .filter((brand) =>
                  brand?.name
                    ?.toLowerCase()
                    ?.includes(effectiveKeyword?.toLowerCase()),
                )
                .map((brand) => brand?._id)
                .filter(Boolean)
            : [];

        const productFilter = { ...baseFilter };

        if (matchedBrandIds.length === 1) {
          productFilter['brand.id'] = matchedBrandIds[0];
        } else if (matchedBrandIds.length > 1) {
          productFilter['brand.id'] = matchedBrandIds.join(',');
        } else if (effectiveKeyword && effectiveKeyword.trim().length) {
          productFilter['$or'] = [
            { 'product.name': { $regex: effectiveKeyword, $options: 'i' } },
          ];
        }

        const hasAssortmentFilter = Boolean(
          productFilter['brand.id'] || productFilter['$or'],
        );

        const promises = [];

        promises.push(
          requestWithTimeout(
            getProductSearch.request('visibility-update', {
              params: {
                filter: baseFilter,
                skip: product_skip,
                limit: searchLimit,
                sort: 'product.name',
              },
            }),
          ),
        );

        if (hasAssortmentFilter) {
          promises.push(
            requestWithTimeout(
              getProducts.request(
                market_type?.id,
                isNonGT
                  ? market_type?.business_type?.account?.id
                  : market_type?.business_type?.id,
                {
                  params: {
                    filter: productFilter,
                    skip: product_skip,
                    limit: searchLimit,
                    sort: 'product.name',
                  },
                },
              ),
            ),
          );
        }

        const [searchResponse, productsResponse] = await Promise.allSettled(
          promises,
        );

        let hasSearchResult = false;
        let rawSearchCount = 0;
        let rawProductsCount = 0;

        if (searchResponse.status === 'fulfilled') {
          const response = searchResponse.value;
          const searchResponseData = flattenVisibilitySearchResponse(
            response?.data?.data,
          );
          rawSearchCount = searchResponseData?.length ?? 0;
          if (searchResponseData?.length) {
            const normalizedSearchProducts = normalizeVisibilityApiProducts(
              searchResponseData,
              {
                splitCombinations: true,
              },
            );
            const filteredSearchProducts = filterVisibilityProductsByKeyword(
              normalizedSearchProducts,
              effectiveKeyword,
            );
            const result = applyExactEanMatch(
              filteredSearchProducts,
              effectiveKeyword,
            );

            if (result.length > 0) {
              res_new_products = res_new_products.concat(result);
              res_products = res_products.concat(result);
              hasSearchResult = true;
            }
          }
        }

        if (hasAssortmentFilter) {
          if (productsResponse.status === 'fulfilled') {
            const response = productsResponse.value;
            const productsResponseData = Array.isArray(response?.data?.data)
              ? response.data.data
              : null;
            rawProductsCount = productsResponseData?.length ?? 0;
            if (productsResponseData?.length) {
              const normalizedBrandProducts =
                normalizeVisibilityApiProducts(productsResponseData);
              const filteredBrandProducts = filterVisibilityProductsByKeyword(
                normalizedBrandProducts,
                effectiveKeyword,
              );
              const result = applyExactEanMatch(
                filteredBrandProducts,
                effectiveKeyword,
              );

              if (result.length > 0) {
                res_new_products = res_new_products.concat(result);
                res_products = res_products.concat(result);
                hasSearchResult = true;
              }
            }
          }
        }

        if (hasSearchResult) {
          res_products = dedupeVisibilityProducts(
            mergeProductsByCombination(res_products),
          );
          res_new_products = dedupeVisibilityProducts(res_new_products);

          if (res_new_products.length > searchLimit) {
            res_new_products = res_new_products.slice(0, searchLimit);
            const previousList =
              product_skip > 0 ? listProductSearchRef.current || [] : [];
            res_products = dedupeVisibilityProducts([
              ...previousList,
              ...res_new_products,
            ]);
          }

          res_products = applyExactEanMatch(res_products, effectiveKeyword);
          res_new_products = applyExactEanMatch(
            res_new_products,
            effectiveKeyword,
          );

          setListProductSearch(res_products);

          const searchApiDone = rawSearchCount < searchLimit;
          const productsApiDone =
            !hasAssortmentFilter || rawProductsCount < searchLimit;
          setEmpty((prev) => ({
            ...prev,
            search: searchApiDone && productsApiDone,
          }));
        } else {
          if (product_skip <= 0) {
            setListProductSearch([]);
            setListBrand([]);
            setListProduct({ other_search: [] });
            setSelectedBrand([]);
            setEmpty((prev) => ({ ...prev, search: true }));
          } else {
            setEmpty((prev) => ({ ...prev, search: true }));
          }
        }
      }

      if (res_products?.length) {
        const result = formatVisibilityProductsForList(res_products);
        const result_selected =
          extractVisibilitySelectedProducts(res_new_products);

        if (result_selected?.length) {
          const result_lists = lastPayloadRef.current.concat(
            result_selected
              .map((pr) => convertProductResult(pr))
              .filter(
                (pr) =>
                  !pr?.combination?.is_other &&
                  !lastPayloadRef.current.some(
                    (item) =>
                      item.brand.id === pr.brand.id &&
                      item.combination.id === pr.combination.id,
                  ),
              ),
          );
          setLastPayload(result_lists);

          const result_other_lists = lastPayloadOtherRef.current.concat(
            result_selected
              .map((pr) => convertProductResult(pr))
              .filter(
                (pr) =>
                  pr?.combination?.is_other &&
                  !lastPayloadOtherRef.current.some(
                    (item) =>
                      item.brand.id === pr.brand.id &&
                      item.combination.id === pr.combination.id,
                  ),
              ),
          );
          setLastPayloadOther(result_other_lists);
        }

        if (brand_id) {
          const newProductsRaw = result.filter(
            (pr) => !pr?.combination?.is_other,
          );
          const newProducts = dedupeVisibilityProducts(newProductsRaw);
          const currentBrandProducts = listProductRef.current?.[brand_id] || [];
          if (
            product_skip > 0 &&
            newProducts.length <= currentBrandProducts.length
          ) {
            setEmpty((prev) => ({ ...prev, [brand_id]: true }));
          }
          const hasChanged = isBrandProductsChanged(
            currentBrandProducts,
            newProducts,
          );
          const nextProductsByBrand = {
            ...sanitizeVisibilityProductsByBrand(listProductRef.current),
            [brand_id]: newProducts,
          };
          if (hasChanged) {
            setListProduct(nextProductsByBrand);
          }
          if (!effectiveKeyword || !effectiveKeyword.trim().length) {
            await persistBrowseSnapshot({
              brands:
                (Array.isArray(brandListsRef.current) &&
                brandListsRef.current.length
                  ? brandListsRef.current
                  : listBrandRef.current) ?? [],
              productsByBrand: nextProductsByBrand,
              skipValue: {
                ...skipRef.current,
                [brand_id]: product_skip,
              },
              emptyValue: emptyRef.current,
              selectedBrands: selectedBrand,
            });
          }
        } else {
          const { brands, productsByBrand } =
            buildVisibilityProductBuckets(result);
          const brandArray = brands.map((brand) => brand._id);
          if (brands.length) {
            setSelectedBrand(brandArray);
            setListBrand(
              brands.map((brand) => ({
                ...brand,
                _expanded: true,
              })),
            );
          } else {
            setSelectedBrand([]);
            setListBrand([]);
          }

          setListProduct(productsByBrand);
        }
      } else {
        if (brand_id) {
          const currentBrandProducts = listProductRef.current?.[brand_id] || [];
          if (currentBrandProducts.length) {
            setListProduct((prev) => ({
              ...sanitizeVisibilityProductsByBrand(prev),
              [brand_id]: [],
            }));
          }
          if (!effectiveKeyword || !effectiveKeyword.trim().length) {
            const nextProductsByBrand = {
              ...sanitizeVisibilityProductsByBrand(listProductRef.current),
              [brand_id]: [],
            };
            await persistBrowseSnapshot({
              brands:
                (Array.isArray(brandListsRef.current) &&
                brandListsRef.current.length
                  ? brandListsRef.current
                  : listBrandRef.current) ?? [],
              productsByBrand: nextProductsByBrand,
              skipValue: {
                ...skipRef.current,
                [brand_id]: product_skip,
              },
              emptyValue: emptyRef.current,
              selectedBrands: selectedBrand,
            });
          }
        }
      }

      if (brand_id) {
        setLoadingProduct(brand_id, false, product_skip > 0);
      } else {
        setLoadingProduct('search', false, product_skip > 0);
      }
    } catch (error) {
      if (brand_id) {
        setLoadingProduct(brand_id, false, product_skip > 0);
      } else {
        setLoadingProduct('search', false, product_skip > 0);
      }
    } finally {
      if (brand_id) {
        setLoadingProduct(brand_id, false, product_skip > 0);
        // Force update listBrand to ensure re-render after loading state change
        setListBrand((prev) =>
          prev.map((item) =>
            item._id === brand_id ? { ...item, _updated: Date.now() } : item,
          ),
        );
      } else {
        setLoadingProduct('search', false, product_skip > 0);
      }
    }
  };

  const onSearchBrands = async () => {
    try {
      const filter = {};
      const market_type = detailCustomer?.market_type;
      const market_type_code = market_type?.code.toLowerCase();
      const account_id =
        detailCustomer?.market_type?.business_type?.account?.id;
      const isNonGT =
        account_id && account_id.length && market_type_code != 'gt';
      const addressIsPremium = customerAddress?.address?.is_premium;
      if (isNonGT) {
        filter.account_id = account_id;
      }
      if (addressIsPremium !== undefined && addressIsPremium !== null) {
        filter.is_premium = addressIsPremium;
      }
      const response = await requestWithTimeout(
        getBrands.request(
          market_type?.id,
          isNonGT
            ? market_type?.business_type?.account?.id
            : market_type?.business_type?.id,
          {
            params: {
              filter: filter,
              skip: 0,
              limit: 50,
            },
          },
        ),
      );

      if (response.status == 200 && response?.data?.data?.length) {
        const result = normalizeVisibilityBrandList(
          response.data.data
            .map((br) => {
              return {
                _id: br?.brand?.id ? br.brand.id : br?._id,
                name: br?.brand?.name ? br.brand.name : br?.name,
              };
            })
            .sort((a, b) =>
              a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
            ),
        );

        const nextSelectedBrand = (
          browseSnapshotRef.current?.selectedBrand ||
          selectedBrand ||
          []
        ).filter((brandId) => result.some((brand) => brand._id === brandId));

        brandListsRef.current = JSON.parse(JSON.stringify(result));

        setSelectedBrand(nextSelectedBrand);
        setListBrand(applyExpandedVisibilityBrands(result, nextSelectedBrand));
        await persistBrowseSnapshot({
          brands: result,
          productsByBrand: listProductRef.current,
          skipValue: skipRef.current,
          emptyValue: emptyRef.current,
          selectedBrands: nextSelectedBrand,
        });
      } else {
        setListBrand([]);
      }
    } catch (error) {}
  };

  const handleBarcodeScan = useCallback(
    async (barcode) => {
      if (!barcode || !barcode.trim()) {
        return;
      }

      const trimmedBarcode = barcode.trim();
      setShowScanner(false);
      setScannedEAN(trimmedBarcode);
      setSearchQuery(trimmedBarcode);
      setDebouncedQuery(trimmedBarcode);
      setIsBarcodeScanning(true);

      if (!showProduct) {
        setShowProduct(true);
      }

      try {
        setTimeout(() => {
          onSearchProducts({ keyword: trimmedBarcode });
        }, 100);
      } catch (error) {
        console.warn('Error searching product by barcode:', error);
        setTimeout(() => {
          onSearchProducts({ keyword: trimmedBarcode });
        }, 100);
      }
    },
    [showProduct, onSearchProducts],
  );

  const handleRemoveScannedEAN = useCallback(() => {
    setScannedEAN('');
    setSearchQuery('');
    setDebouncedQuery('');
    setIsBarcodeScanning(false);
    if (showProduct) {
      onSearchProducts({ keyword: '' });
    }
  }, [showProduct, onSearchProducts]);

  const handleCloseProductNotFoundModal = useCallback(() => {
    setShowProductNotFoundModal(false);
    setScannedEAN('');
    setSearchQuery('');
    setDebouncedQuery('');
    setIsBarcodeScanning(false);
    onReset();
    onSearchBrands();
    if (showProduct) {
      onSearchProducts({ keyword: '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showProduct]);

  return (
    <View
      testID="todo-visibility-update-container"
      style={{ width: '100%', height: containerHeight }}>
      {showProduct ? (
        <VisibilityBrowseSection
          getBrandsLoading={getBrands?.loading}
          loading={loading}
          listBrand={listBrand}
          scannedEAN={scannedEAN}
          isBarcodeScanning={isBarcodeScanning}
          setScannedEAN={setScannedEAN}
          setIsBarcodeScanning={setIsBarcodeScanning}
          onSearchProducts={onSearchProducts}
          searchQuery={searchQuery}
          setShowScanner={setShowScanner}
          handleRemoveScannedEAN={handleRemoveScannedEAN}
          isSearch={isSearch}
          onExpand={onExpand}
          selectedBrand={selectedBrand}
          listProduct={listProduct}
          empty={empty}
          loadingMore={loadingMore}
          skip={skip}
          lastPayload={lastPayload}
          detailData={detailData}
          detailTodo={detailTodo}
          handleProductUpdate={handleProductUpdate}
          customerAddress={customerAddress}
          navigation={navigation}
          lastPayloadOther={lastPayloadOther}
          setLastPayloadOther={setLastPayloadOther}
          isHasSearchLoadMore={isHasSearchLoadMore}
          setShowProduct={setShowProduct}
          setSearchQuery={setSearchQuery}
          accountGroupId={
            detailCustomer?.market_type?.business_type?.account?.id || null
          }
          isValueSellOutOnly={isValueSellOutOnly}
        />
      ) : (
        <VisibilitySelectedSection
          lastPayload={lastPayload}
          lastPayloadOther={lastPayloadOther}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          filterProducts={filterProducts}
          detailData={detailData}
          detailTodo={detailTodo}
          handleProductUpdate={handleProductUpdate}
          customerAddress={customerAddress}
          navigation={navigation}
          showProduct={showProduct}
          setShowProduct={setShowProduct}
          missingFieldData={missingFieldData}
          isLoadingGlobal={isLoadingGlobal}
          onSubmitProduct={onSubmitProduct}
          setMissingFieldData={setMissingFieldData}
          setModalValidation={setModalValidation}
          modalValidation={modalValidation}
          accountGroupId={
            detailCustomer?.market_type?.business_type?.account?.id || null
          }
          isValueSellOutOnly={isValueSellOutOnly}
        />
      )}
      <BarcodeScanner
        show={showScanner && showProduct}
        onClose={() => setShowScanner(false)}
        onScan={handleBarcodeScan}
      />
      <VisibilityProductNotFoundModal
        visible={showProductNotFoundModal}
        onClose={handleCloseProductNotFoundModal}
      />
      <VisibilityValidationModal
        visible={modalValidation}
        products={missingFieldData}
        onUpdateField={onUpdateValidationField}
        onClose={() => {
          setMissingFieldData([]);
          setModalValidation(false);
        }}
      />
      <Alert />
    </View>
  );
};

export default React.memo(TodoVisibilityUpdate, (prev, next) => prev == next);
